<template>
  <div class="arrow" :class="choiceColor">
    <b>{{fixedValue}}</b>
    <i v-show="showArray"></i>
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps(['value'])

const showArray = computed(() => {
  return !(props.value === null || props.value === undefined || props.value === 0);
})

const fixedValue = computed(() => {
  if(notExist(props)){
    return '-';
  }
  // else if(props.value === 0){
  //   return 0;
  // }
  else{
    return Number(props.value * 100).toFixed(2) + '%';
  }
})

const choiceColor = computed(() => {
    if(notExist(props) || props.value === 0){
      return '';
    }else{
      // 大于0红色 小于0绿色
      return Number(props.value) > 0 ? 'arrow-up' :  'arrow-down';
    }
})

function notExist(v){
  return v.value===null || v.value===undefined;
}
</script>

<style lang="less" scoped>
.arrow{
  display: flex;
  flex-direction: row;
  font-size: 16px;
  margin-top: 6px;
  width: 80px;
  font-weight: bold;
  justify-content: space-between;

  &-up{
    color: red;
  }

  &-down{
    color: green;
    & i{
      transform-origin: center center;
      transform: rotate(180deg);
    }
  }
}

i::before{
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e6cd"
}
</style>